// src/pages/ViewProfile.js
import React from 'react';
import { useUser } from '../Context/UserContext';
import '../Css/viewProfile.css';

const ViewProfile = () => {
  const { user } = useUser();

  return (
    <div className='profile-container'>
      <h2>View Profile</h2>
      <div className='profile-info'>
        <div className='profile-item'>
          <strong>Email:</strong>
          <p>{user.email || 'Loading...'}</p>
        </div>
        <div className='profile-item'>
          <strong>Role:</strong>
          <p>{user.role || 'Loading...'}</p>
        </div>
      </div>
    </div>
  );
};

export default ViewProfile;
